var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.969 21.31C21.969 21.9169 21.4774 22.4084 20.8705 22.4084H14.2798C13.6729 22.4084 13.1814 21.9169 13.1814 21.31V18.0146H0V27.9007C0 29.6582 1.53783 31.196 3.29535 31.196H31.855C33.6125 31.196 35.1504 29.6582 35.1504 27.9007V18.0146H21.969V21.31ZM31.855 7.03015H26.3628V3.7348C26.3628 1.97728 24.825 0.439453 23.0674 0.439453H12.0829C10.3254 0.439453 8.78759 1.97728 8.78759 3.7348V7.03015H3.29535C1.53783 7.03015 0 8.56798 0 10.3255V15.8177H35.1504V10.3255C35.1504 8.56798 33.6125 7.03015 31.855 7.03015ZM21.969 7.03015H13.1814V4.83325H21.969V7.03015Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.03ba2b8f3a24b30f410471c2eb8ae124.svg";
export { ForwardRef as ReactComponent };